import { Currency } from '@/core/currency/interfaces';

const NAD: Currency = {
    name: 'Namibian Dollar',
    demonym: 'Namibian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '516',
    symbol: 'N$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NAD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default NAD;
